import appboy from '@braze/web-sdk';

import { config } from 'src/config';
import { logFactory } from 'src/shared/log';

import { isDevelopment } from '../helpers/environment';

const baseUrl = 'https://sdk.iad-03.braze.com/api/v3';
const options = { baseUrl, isLoggingEnabled: false };

export type Appboy = typeof appboy;

let braze: Appboy;

const log = logFactory('telemetry:braze');

export const initializeBraze = async () => {
  if (braze) return braze;

  if (!config.BRAZE_API_KEY) {
    const message = 'Braze: cannot initialize without setting `BRAZE_API_KEY`';

    if (isDevelopment()) {
      log(message);

      return undefined;
    }

    throw new Error(message);
  }

  braze = (
    await import(
      /* webpackChunkName: "braze" */
      '@braze/web-sdk'
    )
  ).default;

  braze.initialize(config.BRAZE_API_KEY, options);

  return braze;
};
